import React from "react";
import { CustomButton2, CustomModal } from "../../../../components";
import Context from "../../../../context";
import "./index.sass";
import { Container, Row } from "react-bootstrap";
import Column from "../../../../components/CustomView/Column";
import { ICreateAndUpdateClient } from "../../../../types/client.interface";

const Delete = () => {
  // ** ===========================================================================================================
  // **                                            Value Validation
  // ** -----------------------------------------------------------------------------------------------------------
  const { showModal, setShowModal, removeClient, selectedClient, loading } =
    React.useContext(Context.ClientScreen);

  const submitHandler = () => {
    removeClient!(selectedClient?._id as string);
  };

  // ?? ===========================================================================================================
  // ??                                              JSX Content
  // ?? -----------------------------------------------------------------------------------------------------------

  return (
    <section id="driver-update-modal-container">
      <CustomModal
        onClose={() => setShowModal!("NONE")}
        open={showModal === "DELETE"}
        minWidth={"22rem"}
      >
        <form>
          <Container>
            <Row>
              <Column>
                <p style={{ fontSize: "0.9rem" }}>
                  آیا از خذف این مشتری مطمئن هستید؟
                </p>
              </Column>
            </Row>
            <div style={{ marginTop: "1rem" }}>
              <Row>
                <Column>
                  <CustomButton2
                    title={"تأیید"}
                    type="primary"
                    onClick={submitHandler}
                    isLoading={loading}
                  />
                </Column>
              </Row>
            </div>
          </Container>
        </form>
      </CustomModal>
    </section>
  );
};

export default Delete;
